import React, { useState } from "react";
import { useParams } from 'react-router-dom';
import { Card, InputNumber, Button, Row, Col, Typography, message } from "antd";
import Logo from "../../../../assets/images/svg/logo-one.png";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import authentication from "../../../../redux/authentication";
import API from "../../../../axios/apiHelper";
import { UserRoleEnum } from "../../../../types/enums";
import { useAuthentication } from '../../../../context/AuthProvider';

const { Text } = Typography;

const VerificationOTP = (props) => {
  const { actions } = props;
  const [otpValue, setOtpValue] = useState();
  const [loading, setLoading] = useState(false);
  const { verifyOTP, resendOTP, subscribeOTP } = useAuthentication();
  const params = useParams();

  function resendOtpVerification() {
    resendOTP({ userId: params.userId })
  }

  function onVerifyOtp() {
    setLoading(true);
    verifyOTP({ 
      userId: params.userId, 
      otp: otpValue 
    })
    .catch(() => setLoading(false));
  }

  return (
    <div className="verification-wrapper">
      <Card style={{ width: 320 }}>
        <img src={Logo} alt="logo" className="verification-image-logo" />

        <Row gutter={24} className="verification-row">
          <Col span={24}>
            <Text className="primary-font-color">
              <b>Enter the One Time Password (OTP) sent to your E-mail or Phone.</b>
            </Text>
          </Col>

          <Col span={24}>
            <InputNumber
              id="otp-code-input"
              onChange={setOtpValue}
              onPressEnter={onVerifyOtp}
              placeholder="Enter One Time Password"
              style={{ width: "100%" }}
            />
          </Col>
          <Col span={24}>
            <Button
              id="otp-verify-btn"
              type="primary"
              style={{ width: "100%" }}
              loading={loading}
              onClick={onVerifyOtp}
            >
              Verify OTP
            </Button>
          </Col>
          <Col span={24}>
            <Text>
              <b>OTP is valid for 10 minutes</b>
            </Text>
          </Col>
          <Col span={24}>
            <Text
              onClick={() => resendOtpVerification()}
              style={{ cursor: "pointer", color: "#7bad7e" }}
            >
              <b>Resend OTP</b>
            </Text>
            <br />
            <span style={{ fontSize: "12px", display: "inline-block", marginTop: "20px" }}>
              Still not receiving the OTP?
              <br />
              <Text
                style={{
                  cursor: "pointer",
                  color: "#7bad7e",
                  fontWeight: "bold",
                  fontSize: "13px",
                }}
                onClick={() => subscribeOTP({ userId: params.userId })}
              >
                Resend 2FA Subscription Email
              </Text>
            </span>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  const { verfiyAuthenticationOtp } = authentication.actions;
  return {
    actions: bindActionCreators(
      {
        verfiyAuthenticationOtp,
      },
      dispatch
    ),
  };
};

export default connect(null, mapDispatchToProps)(VerificationOTP);
